var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{class:{
    'lang-en': _vm.lang === 'en',
    'new-header-bg': _vm.isSpecialRoute,
    customNavbar: false,
    secondSpecialRoute: true,
  },attrs:{"id":"app"}},[_c('Navbar'),_c('router-view'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }